import './NotificationsForm.scss';

import React from 'react';
import { validated } from 'react-custom-validation'
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import { handleCheckboxChange, handleTextChange } from 'utils/handle-changes';
import { isEqual, isRequired } from 'utils/validations';

import Button from 'components/Button/index';
import Form from 'components/Form/index';
import FormColumn from 'components/FormColumn/index';
import FormRow from 'components/FormRow/index';
import FormValidationMessage from 'components/FormValidationMessage/index';
import H3 from 'components/H3/index';
import LoadingCircle from 'components/LoadingCircle/index';
import Textbox from 'components/Textbox/index';
import ToggleSwitch from 'components/ToggleSwitch/index';

class NotificationsForm extends React.Component {
    static propTypes = {
        credentials: PropTypes.object.isRequired,
        error: PropTypes.object.isRequired,
        isSaving: PropTypes.bool.isRequired,
        onInvalid: PropTypes.func.isRequired,
        onValid: PropTypes.func.isRequired,
        setCredentials: PropTypes.func.isRequired,
        setUser: PropTypes.func.isRequired,
        user: PropTypes.object.isRequired
    };

    _handleChange(name, value, object) {
        /*if(object === 'user') {*/
            let newUserObj = update(this.props.user, {});
            newUserObj[name] = value;
            this.props.setUser(newUserObj);
        /*} else {
            let newCredentialsObj = update(this.props.credentials, {});
            newCredentialsObj[name] = value;
            this.props.setCredentials(newCredentialsObj);
        }*/
    }

    render() {
        let { error, isSaving, onInvalid, onValid, user, $field, $validation } = this.props;

        return (
            <Form className="notifications-form">
                <FormRow columnCount={2}>
                    <FormColumn>
                        <H3>
                            Change Password
                        </H3>

                        {/*<FormRow>
                            <Textbox
                                label="Current Password"
                                id="txtCurrentPassword"
                                name="password"
                                required
                                type="password"
                                validation={$validation.currentPassword}
                                value={credentials.password}
                                {...$field('currentPassword', (event) => handleTextChange(this._handleChange.bind(this), event, 'credentials'))}
                            />
                        </FormRow>*/}

                        <FormRow>
                            <Textbox
                                label="New Password"
                                id="txtNewPassword"
                                name="password"
                                required
                                type="password"
                                validation={$validation.password}
                                value={user.password}
                                {...$field('password', (event) => handleTextChange(this._handleChange.bind(this), event, 'user'))}
                            />
                        </FormRow>

                        <FormRow>
                            <Textbox
                                label="Confirm New Password"
                                id="txtNewPassword2"
                                name="password2"
                                required
                                type="password"
                                validation={$validation.password2}
                                value={user.password2}
                                {...$field('password2', (event) => handleTextChange(this._handleChange.bind(this), event, 'user'))}
                            />
                        </FormRow>

                        {this.props.user.role === 'agency' ? (
                            <FormRow className="a-form-row--toggle-switch-wrapper">
                                <ToggleSwitch
                                    checked={user.notificationFavoriteFreelancer === true}
                                    label="When favorite freelancer becomes available"
                                    labelPosition="left"
                                    name="notificationFavoriteFreelancer"
                                    onChange={(event) => handleCheckboxChange(this._handleChange.bind(this), event)}
                                />
                            </FormRow>
                        ) : null}
                    </FormColumn>
                </FormRow>

                {Object.keys(error).length > 0 ? (
                    <FormRow className="error-message">
                        <FormValidationMessage>
                            {error.friendlyMessage || error.message}
                        </FormValidationMessage>
                    </FormRow>
                ) : null}

                <FormRow className="button-wrapper">
                    <Button disabled={isSaving === true}
                            onClick={(event) => {
                                event.preventDefault();
                                this.props.$submit(onValid, onInvalid);
                            }}
                            type="submit">
                        Update
                        {isSaving === true ? <LoadingCircle innerColor="#ffffff" outerColor="#ffffff" /> : null}
                    </Button>
                </FormRow>
            </Form>
        );
    }
}

function notificationsFormValidationConfig(props) {
    const { password, password2} = props.user;

    return {
        fields: ['password', 'password2'],
        validations: {
            /*currentPassword: [
                [isRequired, currentPassword],
            ],*/
            password: [
                [isRequired, password],
            ],
            password2: [
                [isRequired, password2],
                [isEqual, password, password2, 'Passwords must match']
            ]
        }
    }
}

export default NotificationsForm = validated(notificationsFormValidationConfig)(NotificationsForm);



// WEBPACK FOOTER //
// ./src/containers/Accounts/Edit/SecurityForm.js